<template>
    <div :class="'counter-' + type" class="counter">
        <div class="counter-numbers">
            <div v-if="total >= 0">
                {{ calcCurrent }}<span class="total-separator">/</span>{{ total }}
                <!-- X of Y -->
            </div>
            <div v-else>
                {{ current }}
                <!-- X -->
            </div>
        </div>
        <span class="counter-label"><slot></slot></span>
    </div>
</template>

<script>
    export default {
        name: 'counter',
        props: {
            current: {
                type: Number,
                required: false,
                default: 0
            },
            total: {
                type: Number,
                required: false,
                default: -1
            }
        },
        computed: {
            type() {
                if (this.hasDefaultSlot) {
                    return 'with-label'
                } else {
                    return 'no-label'
                }
            },
            hasDefaultSlot() {
                return !!this.$slots.default
            },
            calcCurrent() {
                return Math.min(this.current, this.total);
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/font-sizes.less";
    @import "~@less/mixins/mixins.less";

    @counterWidth: 155px;
    @counterHeight: 60px;

    .counter {
        width: @counterWidth;
        height: @counterHeight;

        background: url("~@img/misc/counter.png") no-repeat top left;

        font-weight: bold;
        font-family: "Titillium Web", sans-serif;

        padding-left: 50px;
        text-align: center;

        &.counter-no-label {
            padding-top: 12px;
        }

        &.counter-with-label {
            padding-top: 8px;
        }

        .counter-numbers {
            font-size: @app-font-size-counter-numbers;
            line-height: 15pt;
        }

        .counter-label {
            position: relative;
            font-size: @app-font-size-counter-label;
            line-height: @app-font-size-counter-label;
        }
    }

    .media-lg({ .counter {
        width: @counterWidth * @size-percentage-lg;
        height: @counterHeight * @size-percentage-lg;
    } .counter-label {
          top: 5px;
      } });

    .media-xl({ .counter {
        width: @counterWidth * @size-percentage-xl;
        height: @counterHeight * @size-percentage-xl;
    } .counter-label {
          top: 8px;
      } });

    .media-xxl({ .counter {
        width: @counterWidth * @size-percentage-xxl;
        height: @counterHeight * @size-percentage-xxl;
    } .counter-label {
          top: 11px;
      } });
</style>